<template>
  <div class="flex flex-col p-6 gap-y-4">
    <div class="flex flex-col">
      <CHeading :level="5">{{ retailer.name }}</CHeading>
    </div>
    <address>
      <CText v-if="retailer.address" element="span" variant="system-sm">{{ retailer.address }}</CText>
    </address>
    <div v-if="!!retailer.offerings?.length" class="flex flex-wrap gap-x-2">
      <div v-for="offering in retailer.offerings" :key="offering" class="flex items-center gap-x-2">
        <CIcon name="check_box" />
        <CText el="span" variant="system-sm" class="whitespace-nowrap">
          {{ offering }}
        </CText>
      </div>
    </div>

    <slot v-if="hasFooterContent" name="footer-content" />
    <div v-else class="flex items-center justify-end">
      <CLink
        variant="primary"
        size="small"
        icon="open_in_new"
        icon-position="right"
        :to="retailer.link"
        target="_blank"
        data-test="retailer-link"
      >
        {{ t('store.to_retailer') }}
      </CLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type RetailerDetails = {
  name: string;
  address: string;
  offerings: string[] | null;
  link: string;
};

type Props = {
  retailer: RetailerDetails;
};

defineProps<Props>();

const { t } = useI18n();
const slots = useSlots();

const hasFooterContent = computed(() => !!slots['footer-content']);
</script>

<script lang="ts">
export default defineComponent({
  name: 'RetailerDetailsCard',
});
</script>
